module.exports = new __parcel__URL__("shop_machines_gooh_refinery.2cc313c9.png").toString();